import { Box, Center, Spinner } from '@chakra-ui/react';
import EventGridCarousel from 'presentation/components/modules/events/grid/EventGridCarousel';
import EventGridItem from 'presentation/components/modules/events/grid/EventGridItem';
import AppCard from 'presentation/components/shared/card/AppCard';
import ErrorContainer from 'presentation/components/shared/ErrorContainer';
import { FC } from 'react';
import { useFetchEventCategoryDetailQuery } from 'rtkQuery/sharespro/queries/events';

interface Props {
  categoryId: ID;
}

const UpcomingEventsByCategoryContainer: FC<Props> = ({ categoryId }) => {
  const { data, isFetching, error, refetch } = useFetchEventCategoryDetailQuery(categoryId);

  let wrapByCard = true;
  let content;
  if (data) {
    if (data.nextEvents.length === 0) return null;
    if (data.nextEvents.length > 1) {
      content = <EventGridCarousel events={data.nextEvents}/>;
    } else {
      content = <EventGridItem data={data.nextEvents[0]} height={250} />;
    }
    wrapByCard = false;
  } else if (isFetching) {
    content = <Spinner />;
  } else if (error) {
    content = (
      <ErrorContainer
        error={error}
        onRetry={() => {
          refetch();
        }}
      />
    );
  } else {
    content = <Spinner />;
  }
  if (wrapByCard) {
    content = (
      <AppCard p="20px" h="290px">
        <Center h="100%">{content}</Center>
      </AppCard>
    );
  }

  return <Box mb="30px">{content}</Box>;
};

export default UpcomingEventsByCategoryContainer;
